export default {"src":"/_next/static/media/no-img.f2f53649.svg","height":406,"width":330,"blurWidth":0,"blurHeight":0};